<div class="container-fluid">
    <div class="card bg-dark text-white shadow">
        <img class="card-img" src="./assets/blog.jpg" alt="Card image">
        <div class="card-img-overlay">
            <div class="card-title">Hamarosan...</div>
        </div>
    </div>
</div>